import { render, staticRenderFns } from "./traineeRegistration.vue?vue&type=template&id=7635bcf5&scoped=true"
import script from "./traineeRegistration.vue?vue&type=script&lang=js"
export * from "./traineeRegistration.vue?vue&type=script&lang=js"
import style0 from "./traineeRegistration.vue?vue&type=style&index=0&id=7635bcf5&prod&scoped=true&lang=css"
import style1 from "./traineeRegistration.vue?vue&type=style&index=1&id=7635bcf5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7635bcf5",
  null
  
)

export default component.exports